module.exports = __webpack_public_path__ + "static/media/Enter-Your_city.b9dc5dbc.png";